export const EmojisSmileysAndPeople = [
  { emoji: "😀" },
  { emoji: "😃" },
  { emoji: "😄" },
  { emoji: "😁" },
  { emoji: "😆" },
  { emoji: "😅" },
  { emoji: "🤣" },
  { emoji: "😂" },
  { emoji: "🙂" },
  { emoji: "🙃" },
  { emoji: "😉" },
  { emoji: "😊" },
  { emoji: "😇" },
  { emoji: "🥰" },
  { emoji: "😍" },
  { emoji: "🥳" },
  { emoji: "😘" },
  { emoji: "😗" },
  { emoji: "☺" },
  { emoji: "😚" },
  { emoji: "😙" },
  { emoji: "😋" },
  { emoji: "😛" },
  { emoji: "😜" },
  { emoji: "😝" },
  { emoji: "🤗" },
  { emoji: "🤤" },
  { emoji: "🤩" },
  { emoji: "🤔" },
  { emoji: "🤐" },
  { emoji: "🤨" },
  { emoji: "😐" },
  { emoji: "😑" },
  { emoji: "😶" },
  { emoji: "😶‍🌫️" },
  { emoji: "😏" },
  { emoji: "😒" },
  { emoji: "🙄" },
  { emoji: "😬" },
  { emoji: "🤥" },
  { emoji: "😮‍💨" },
  { emoji: "🙂‍↔️" },
  { emoji: "🙂‍↕️" },
  { emoji: "😌" },
  { emoji: "😔" },
  { emoji: "😪" },
  { emoji: "🤤" },
  { emoji: "😴" },
  { emoji: "😷" },
  { emoji: "🤒" },
  { emoji: "🤢" },
  { emoji: "🤮" },
  { emoji: "🤧" },
  { emoji: "🥵" },
  { emoji: "🥶" },
  { emoji: "🥳" },
  { emoji: "😎" },
  { emoji: "🫣" },
  { emoji: "🧐" },
  { emoji: "😕" },
  { emoji: "😟" },
  { emoji: "☹" },
  { emoji: "😮" },
  { emoji: "😲" },
  { emoji: "😳" },
  { emoji: "🥺" },
  { emoji: "😨" },
  { emoji: "😰" },
  { emoji: "😭" },
  { emoji: "😱" },
  { emoji: "😓" },
  { emoji: "😩" },
  { emoji: "🥱" },
  { emoji: "😤" },
  { emoji: "😠" },
  { emoji: "🙈" },
  { emoji: "🙉" },
  { emoji: "🙊" },
  { emoji: "👋" },
  { emoji: "🫂" },
  { emoji: "✋" },
  { emoji: "👌" },
  { emoji: "🤘" },
  { emoji: "✌" },
  { emoji: "👈" },
  { emoji: "👉" },
  { emoji: "👆" },
  { emoji: "👇" },
  { emoji: "👍" },
  { emoji: "👎" },
  { emoji: "✊" },
  { emoji: "👊" },
  { emoji: "👏" },
  { emoji: "🙌" },
  { emoji: "👐" },
  { emoji: "🤲" },
  { emoji: "🙏" },
  { emoji: "✍" },
  { emoji: "💪" },
  { emoji: "🦵" },
  { emoji: "🦶" },
  { emoji: "👂" },
  { emoji: "👃" },
  { emoji: "🧠" },
  { emoji: "🦷" },
  { emoji: "🦴" },
  { emoji: "👀" },
  { emoji: "👁" },
  { emoji: "👅" },
  { emoji: "👄" },
  { emoji: "👶" },
  { emoji: "🧒" },
  { emoji: "👦" },
  { emoji: "👧" },
  { emoji: "🧑" },
  { emoji: "👱" },
  { emoji: "👨" },
  { emoji: "👩" },
  { emoji: "🙋" },
  { emoji: "🙋‍♂️" },
  { emoji: "🙋‍♀️" },
  { emoji: "🙆" },
  { emoji: "🙆‍♂️" },
  { emoji: "💁" },
  { emoji: "💁‍♂️" },
  { emoji: "🙋" },
  { emoji: "🙋‍♂️" },
  { emoji: "🧑‍⚕️" },
  { emoji: "👩‍⚕️" },
  { emoji: "🧑‍🎓" },
  { emoji: "👩‍🎓" },
  { emoji: "🧑‍🏫" },
  { emoji: "👩‍🏫" },
  { emoji: "🧑‍⚖️" },
  { emoji: "👩‍⚖️" },
  { emoji: "🧑‍🌾" },
  { emoji: "👩‍🌾" },
  { emoji: "🧑‍🍳" },
  { emoji: "👩‍🍳" },
  { emoji: "🧑‍🔧" },
  { emoji: "🧑‍🏭" },
  { emoji: "🧑‍💼" },
  { emoji: "👩‍💼" },
  { emoji: "🧑‍🔬" },
  { emoji: "👩‍🔬" },
  { emoji: "🧑‍💻" },
  { emoji: "🧑‍🎤" },
  { emoji: "👩‍🎤" },
  { emoji: "🧑‍✈️" },
  { emoji: "👩‍✈️" },
  { emoji: "🧑‍🚀" },
  { emoji: "🧑‍🚒" },
  { emoji: "🕵️" },
  { emoji: "💂" },
  { emoji: "👷" },
  { emoji: "👨‍👩‍👦" },
  { emoji: "👨‍👩‍👧‍👦" },
];

export const EmojisSymbols = [
    {emoji: "🩷"},
    {emoji: "❤️"},
    {emoji: "💛"},
    {emoji: "💚"},
    {emoji: "🩵"},
    {emoji: "💙"},
    {emoji: "💜"},
    {emoji: "💝"},
    {emoji: "💔"},
    {emoji: "❤️‍🔥"},
    {emoji: "❣️"},
    {emoji: "💖"},
    {emoji: "💘"},
    {emoji: "☪️"},
    {emoji: "🅰️"},
    {emoji: "🅱️"},
    {emoji: "🅾️"},
    {emoji: "🔈"},
    {emoji: "🔕"},
    {emoji: "🔔"},
    {emoji: "📢"},
    {emoji: "🕛"},
    {emoji: "🏧"},
    {emoji: "🚯"},
    {emoji: "🚰"},
    {emoji: "♿"},
    {emoji: "🚾"},
    {emoji: "⚠️"},
    {emoji: "🚸"},
    {emoji: "⛔"},
    {emoji: "🚫"},
    {emoji: "🚳"},
    {emoji: "🚭"},
    {emoji: "🚷"},
    {emoji: "📵"},
    {emoji: "🔞"},
    {emoji: "☢️"},
    {emoji: "⬆️"},
    {emoji: "↗️"},
    {emoji: "➡️"},
    {emoji: "↘️"},
    {emoji: "⬇️"},
    {emoji: "↙️"},
    {emoji: "⬅️"},
    {emoji: "↖️"},
    {emoji: "↕️"},
    {emoji: "↔️"},
    {emoji: "↩️"},
    {emoji: "↪️"},
    {emoji: "🔄"},
    {emoji: "🛐"},
    {emoji: "▶️"},
    {emoji: "⏩"},
    {emoji: "⏭"},
    {emoji: "⏯"},
    {emoji: "⏪"},
    {emoji: "⏮"},
    {emoji: "⏸"},
    {emoji: "⏹"},
    {emoji: "⏺"},
    {emoji: "⏏️"},
    {emoji: "🎦"},
    {emoji: "📶"},
    {emoji: "📴"},
    {emoji: "♀️"},
    {emoji: "♂️"},
    {emoji: "✖️"},
    {emoji: "➕"},
    {emoji: "➖"},
    {emoji: "➗"},
    {emoji: "♾️"},
    {emoji: "❗"},
    {emoji: "❔"},
    {emoji: "〰️"},
    {emoji: "💲"},
    {emoji: "☑️"},
    {emoji: "✔️"},
    {emoji: "❌"},
    {emoji: "©️"},
    {emoji: "®️"},
    {emoji: "™️"},
    {emoji: "0️⃣"},
    {emoji: "1️⃣"},
    {emoji: "2️⃣"},
    {emoji: "3️⃣"},
    {emoji: "4️⃣"},
    {emoji: "5️⃣"},
    {emoji: "6️⃣"},
    {emoji: "7️⃣"},
    {emoji: "8️⃣"},
    {emoji: "9️⃣"},
    {emoji: "🔟"}
];

export const EmojisFoodAndDrink = [
    {emoji: "🍏"},
    {emoji: "🍎"},
    {emoji: "🍐"},
    {emoji: "🍊"},
    {emoji: "🍋"},
    {emoji: "🍌"},
    {emoji: "🍉"},
    {emoji: "🍇"},
    {emoji: "🍓"},
    {emoji: "🍇"},
    {emoji: "🍈"},
    {emoji: "🍒"},
    {emoji: "🍑"},
    {emoji: "🥭"},
    {emoji: "🍍"},
    {emoji: "🥥"},
    {emoji: "🥝"},
    {emoji: "🍅"},
    {emoji: "🍆"},
    {emoji: "🥑"},
    {emoji: "🫑"},
    {emoji: "🥦"},
    {emoji: "🥬"},
    {emoji: "🌶️"},
    {emoji: "🥒"},
    {emoji: "🫒"},
    {emoji: "🌽"},
    {emoji: "🥕"},
    {emoji: "🫛"},
    {emoji: "🧄"},
    {emoji: "🧅"},
    {emoji: "🥔"},
    {emoji: "🍠"},
    {emoji: "🫚"},
    {emoji: "🥐"},
    {emoji: "🥯"},
    {emoji: "🍞"},
    {emoji: "🥖"},
    {emoji: "🥨"},
    {emoji: "🧀"},
    {emoji: "🥚"},
    {emoji: "🍳"},
    {emoji: "🧈"},
    {emoji: "🥞"},
    {emoji: "🧇"},
    {emoji: "🥓"},
    {emoji: "🥩"},
    {emoji: "🍗"},
    {emoji: "🍖"},
    {emoji: "🦴"},
    {emoji: "🌭"},
    {emoji: "🍔"},
    {emoji: "🍟"},
    {emoji: "🍕"},
    {emoji: "🫓"},
    {emoji: "🥪"},
    {emoji: "🥙"},
    {emoji: "🧆"},
    {emoji: "🌮"},
    {emoji: "🌯"},
    {emoji: "🫔"},
    {emoji: "🥗"},
    {emoji: "🥘"},
    {emoji: "🫕"},
    {emoji: "🥫"},
    {emoji: "🫙"},
    {emoji: "🍝"},
    {emoji: "🍜"},
    {emoji: "🍲"},
    {emoji: "🍛"},
    {emoji: "🍣"},
    {emoji: "🍱"},
    {emoji: "🥟"},
    {emoji: "🦪"},
    {emoji: "🍤"},
    {emoji: "🍙"},
    {emoji: "🍚"},
    {emoji: "🍘"},
    {emoji: "🍥"},
    {emoji: "🥠"},
    {emoji: "🥮"},
    {emoji: "🍢"},
    {emoji: "🍡"},
    {emoji: "🍧"},
    {emoji: "🍨"},
    {emoji: "🍦"},
    {emoji: "🥧"},
    {emoji: "🧁"},
    {emoji: "🍰"},
    {emoji: "🎂"},
    {emoji: "🍮"},
    {emoji: "🍭"},
    {emoji: "🍬"},
    {emoji: "🍫"},
    {emoji: "🍿"},
    {emoji: "🍩"},
    {emoji: "🍪"},
    {emoji: "🌰"},
    {emoji: "🥜"},
    {emoji: "🫘"},
    {emoji: "🍯"},
    {emoji: "🥛"},
    {emoji: "🫗"},
    {emoji: "🍼"},
    {emoji: "🫖"},
    {emoji: "☕"},
    {emoji: "🍵"},
    {emoji: "🧃"},
    {emoji: "🥤"},
    {emoji: "🧋"},
    {emoji: "🍶"},
    {emoji: "🍺"},
    {emoji: "🍻"},
    {emoji: "🥂"},
    {emoji: "🍷"},
    {emoji: "🥃"},
    {emoji: "🍸"},
    {emoji: "🍹"},
    {emoji: "🧉"},
    {emoji: "🍾"},
    {emoji: "🧊"},
    {emoji: "🥄"},
    {emoji: "🍴"},
    {emoji: "🍽️"},
    {emoji: "🥣"},
    {emoji: "🥡"},
    {emoji: "🥢"},
    {emoji: "🧂"}
];

export const EmojisAnimalsAndNature = [
    {emoji: "🐶"},
    {emoji: "🐱"},
    {emoji: "🐭"},
    {emoji: "🐹"},
    {emoji: "🐰"},
    {emoji: "🦊"},
    {emoji: "🐻"},
    {emoji: "🐼"},
    {emoji: "🐻‍❄️"},
    {emoji: "🐨"},
    {emoji: "🐯"},
    {emoji: "🦁"},
    {emoji: "🐮"},
    {emoji: "🐷"},
    {emoji: "🐽"},
    {emoji: "🐸"},
    {emoji: "🐵"},
    {emoji: "🙈"},
    {emoji: "🙉"},
    {emoji: "🙊"},
    {emoji: "🐒"},
    {emoji: "🐔"},
    {emoji: "🐧"},
    {emoji: "🐦"},
    {emoji: "🐤"},
    {emoji: "🐣"},
    {emoji: "🐥"},
    {emoji: "🪿"},
    {emoji: "🦆"},
    {emoji: "🐦‍⬛"},
    {emoji: "🦅"},
    {emoji: "🦉"},
    {emoji: "🦇"},
    {emoji: "🐺"},
    {emoji: "🐗"},
    {emoji: "🐴"},
    {emoji: "🦄"},
    {emoji: "🫎"},
    {emoji: "🐝"},
    {emoji: "🪱"},
    {emoji: "🐛"},
    {emoji: "🦋"},
    {emoji: "🐌"},
    {emoji: "🐞"},
    {emoji: "🐜"},
    {emoji: "🪰"},
    {emoji: "🪲"},
    {emoji: "🪳"},
    {emoji: "🦟"},
    {emoji: "🦗"},
    {emoji: "🕷️"},
    {emoji: "🕸️"},
    {emoji: "🦂"},
    {emoji: "🐢"},
    {emoji: "🐍"},
    {emoji: "🦎"},
    {emoji: "🦖"},
    {emoji: "🦕"},
    {emoji: "🐙"},
    {emoji: "🦑"},
    {emoji: "🪼"},
    {emoji: "🦐"},
    {emoji: "🦞"},
    {emoji: "🦀"},
    {emoji: "🐡"},
    {emoji: "🐠"},
    {emoji: "🐟"},
    {emoji: "🐬"},
    {emoji: "🐳"},
    {emoji: "🐋"},
    {emoji: "🦈"},
    {emoji: "🦭"},
    {emoji: "🐊"},
    {emoji: "🐅"},
    {emoji: "🐆"},
    {emoji: "🦓"},
    {emoji: "🦍"},
    {emoji: "🦧"},
    {emoji: "🦣"},
    {emoji: "🐘"},
    {emoji: "🦛"},
    {emoji: "🦏"},
    {emoji: "🐪"},
    {emoji: "🐫"},
    {emoji: "🦒"},
    {emoji: "🦘"},
    {emoji: "🦬"},
    {emoji: "🐃"},
    {emoji: "🐂"},
    {emoji: "🐄"},
    {emoji: "🫏"},
    {emoji: "🐎"},
    {emoji: "🐖"},
    {emoji: "🐏"},
    {emoji: "🐑"},
    {emoji: "🦙"},
    {emoji: "🐐"},
    {emoji: "🦌"},
    {emoji: "🐕"},
    {emoji: "🐩"},
    {emoji: "🦮"},
    {emoji: "🐕‍🦺"},
    {emoji: "🐈"},
    {emoji: "🐈‍⬛"},
    {emoji: "🪶"},
    {emoji: "🪽"},
    {emoji: "🐓"},
    {emoji: "🦃"},
    {emoji: "🦤"},
    {emoji: "🦚"},
    {emoji: "🦜"},
    {emoji: "🦢"},
    {emoji: "🦩"},
    {emoji: "🕊️"},
    {emoji: "🐇"},
    {emoji: "🦝"},
    {emoji: "🦨"},
    {emoji: "🦡"},
    {emoji: "🦫"},
    {emoji: "🦦"},
    {emoji: "🦥"},
    {emoji: "🐁"},
    {emoji: "🐀"},
    {emoji: "🐿️"},
    {emoji: "🦔"},
    {emoji: "🐾"},
    {emoji: "🐉"},
    {emoji: "🐲"},
    {emoji: "🌵"},
    {emoji: "🎄"},
    {emoji: "🌲"},
    {emoji: "🌳"},
    {emoji: "🌴"},
    {emoji: "🪵"},
    {emoji: "🌱"},
    {emoji: "🌿"},
    {emoji: "☘️"},
    {emoji: "🍀"},
    {emoji: "🎍"},
    {emoji: "🪴"},
    {emoji: "🎋"},
    {emoji: "🍃"},
    {emoji: "🍂"},
    {emoji: "🍁"},
    {emoji: "🪺"},
    {emoji: "🪹"},
    {emoji: "🍄"},
    {emoji: "🐚"},
    {emoji: "🪸"},
    {emoji: "🪨"},
    {emoji: "🌾"},
    {emoji: "💐"},
    {emoji: "🌷"},
    {emoji: "🌹"},
    {emoji: "🥀"},
    {emoji: "🪻"},
    {emoji: "🪷"},
    {emoji: "🌺"},
    {emoji: "🌸"},
    {emoji: "🌼"},
    {emoji: "🌻"},
    {emoji: "🌞"},
    {emoji: "🌝"},
    {emoji: "🌛"},
    {emoji: "🌜"},
    {emoji: "🌚"},
    {emoji: "🌕"},
    {emoji: "🌖"},
    {emoji: "🌗"},
    {emoji: "🌘"},
    {emoji: "🌑"},
    {emoji: "🌒"},
    {emoji: "🌓"},
    {emoji: "🌔"},
    {emoji: "🌙"},
    {emoji: "🌎"},
    {emoji: "🌍"},
    {emoji: "🌏"},
    {emoji: "🪐"},
    {emoji: "💫"},
    {emoji: "⭐"},
    {emoji: "🌟"},
    {emoji: "✨"},
    {emoji: "⚡"},
    {emoji: "☄️"},
    {emoji: "💥"},
    {emoji: "🔥"},
    {emoji: "🌪️"},
    {emoji: "🌈"},
    {emoji: "☀️"},
    {emoji: "🌤️"},
    {emoji: "⛅"},
    {emoji: "🌥️"},
    {emoji: "☁️"},
    {emoji: "🌦️"},
    {emoji: "🌧️"},
    {emoji: "⛈️"},
    {emoji: "🌩️"},
    {emoji: "🌨️"},
    {emoji: "❄️"},
    {emoji: "☃️"},
    {emoji: "⛄"},
    {emoji: "🌬️"},
    {emoji: "💨"},
    {emoji: "💧"},
    {emoji: "💦"},
    {emoji: "🫧"},
    {emoji: "☔"},
    {emoji: "☂️"},
    {emoji: "🌊"},
    {emoji: "🌫️"}
];

export const EmojisActivities = [
    {emoji: "⚽"},
    {emoji: "🏀"},
    {emoji: "🏈"},
    {emoji: "⚾"},
    {emoji: "🥎"},
    {emoji: "🎾"},
    {emoji: "🏐"},
    {emoji: "🏉"},
    {emoji: "🥏"},
    {emoji: "🎱"},
    {emoji: "🪀"},
    {emoji: "🏓"},
    {emoji: "🏸"},
    {emoji: "🏒"},
    {emoji: "🏑"},
    {emoji: "🥍"},
    {emoji: "🏏"},
    {emoji: "🪃"},
    {emoji: "🥅"},
    {emoji: "⛳"},
    {emoji: "🪁"},
    {emoji: "🛝"},
    {emoji: "🏹"},
    {emoji: "🎣"},
    {emoji: "🤿"},
    {emoji: "🥊"},
    {emoji: "🥋"},
    {emoji: "🎽"},
    {emoji: "🛹"},
    {emoji: "🛼"},
    {emoji: "🛷"},
    {emoji: "⛸️"},
    {emoji: "🥌"},
    {emoji: "🎿"},
    {emoji: "⛷️"},
    {emoji: "🏂"},
    {emoji: "🪂"},
    {emoji: "🏋️‍♀️"},
    {emoji: "🏋️‍♂️"},
    {emoji: "🤼‍♀️"},
    {emoji: "🤼‍♂️"},
    {emoji: "🤸‍♀️"},
    {emoji: "🤸"},
    {emoji: "🤸‍♂️"},
    {emoji: "⛹️‍♀️"},
    {emoji: "⛹️"},
    {emoji: "⛹️‍♂️"},
    {emoji: "🤺"},
    {emoji: "🤾‍♀️"},
    {emoji: "🤾"},
    {emoji: "🤾‍♂️"},
    {emoji: "🏌️‍♀️"},
    {emoji: "🏌️"},
    {emoji: "🏌️‍♂️"},
    {emoji: "🏇"},
    {emoji: "🧘‍♀️"},
    {emoji: "🧘"},
    {emoji: "🧘‍♂️"},
    {emoji: "🏄‍♀️"},
    {emoji: "🏄"},
    {emoji: "🏄‍♂️"},
    {emoji: "🏊‍♀️"},
    {emoji: "🏊"},
    {emoji: "🏊‍♂️"},
    {emoji: "🤽‍♀️"},
    {emoji: "🤽"},
    {emoji: "🤽‍♂️"},
    {emoji: "🚣‍♀️"},
    {emoji: "🚣"},
    {emoji: "🚣‍♂️"},
    {emoji: "🧗‍♀️"},
    {emoji: "🧗"},
    {emoji: "🧗‍♂️"},
    {emoji: "🚵‍♀️"},
    {emoji: "🚵"},
    {emoji: "🚵‍♂️"},
    {emoji: "🚴‍♀️"},
    {emoji: "🚴"},
    {emoji: "🚴‍♂️"},
    {emoji: "🏆"},
    {emoji: "🥇"},
    {emoji: "🥈"},
    {emoji: "🥉"},
    {emoji: "🏅"},
    {emoji: "🎖️"},
    {emoji: "🏵️"},
    {emoji: "🎗️"},
    {emoji: "🎫"},
    {emoji: "🎟️"},
    {emoji: "🎪"},
    {emoji: "🤹‍♀️"},
    {emoji: "🤹‍♂️"},
    {emoji: "🎭"},
    {emoji: "🩰"},
    {emoji: "🎨"},
    {emoji: "🎬"},
    {emoji: "🎤"},
    {emoji: "🎧"},
    {emoji: "🎼"},
    {emoji: "🎹"},
    {emoji: "🪇"},
    {emoji: "🥁"},
    {emoji: "🪘"},
    {emoji: "🎷"},
    {emoji: "🎺"},
    {emoji: "🪗"},
    {emoji: "🎸"},
    {emoji: "🪕"},
    {emoji: "🎻"},
    {emoji: "🪈"},
    {emoji: "🎲"},
    {emoji: "♟️"},
    {emoji: "🎯"},
    {emoji: "🎳"},
    {emoji: "🎮"},
    {emoji: "🎰"},
    {emoji: "🧩"}
];

export const EmojisTravelAndPlaces = [
    {emoji: "🚗"},
    {emoji: "🚕"},
    {emoji: "🚙"},
    {emoji: "🚌"},
    {emoji: "🚎"},
    {emoji: "🏎️"},
    {emoji: "🚓"},
    {emoji: "🚑"},
    {emoji: "🚒"},
    {emoji: "🚐"},
    {emoji: "🛻"},
    {emoji: "🚚"},
    {emoji: "🚛"},
    {emoji: "🚜"},
    {emoji: "🦯"},
    {emoji: "🦽"},
    {emoji: "🦼"},
    {emoji: "🩼"},
    {emoji: "🛴"},
    {emoji: "🚲"},
    {emoji: "🛵"},
    {emoji: "🏍️"},
    {emoji: "🛺"},
    {emoji: "🛞"},
    {emoji: "🚨"},
    {emoji: "🚔"},
    {emoji: "🚍"},
    {emoji: "🚘"},
    {emoji: "🚖"},
    {emoji: "🚡"},
    {emoji: "🚠"},
    {emoji: "🚟"},
    {emoji: "🚃"},
    {emoji: "🚋"},
    {emoji: "🚞"},
    {emoji: "🚝"},
    {emoji: "🚄"},
    {emoji: "🚅"},
    {emoji: "🚈"},
    {emoji: "🚂"},
    {emoji: "🚆"},
    {emoji: "🚇"},
    {emoji: "🚊"},
    {emoji: "🚉"},
    {emoji: "✈️"},
    {emoji: "🛫"},
    {emoji: "🛬"},
    {emoji: "🛩️"},
    {emoji: "💺"},
    {emoji: "🛰️"},
    {emoji: "🚀"},
    {emoji: "🛸"},
    {emoji: "🚁"},
    {emoji: "🛶"},
    {emoji: "⛵"},
    {emoji: "🚤"},
    {emoji: "🛥️"},
    {emoji: "🛳️"},
    {emoji: "⛴️"},
    {emoji: "🚢"},
    {emoji: "🛟"},
    {emoji: "⚓"},
    {emoji: "🪝"},
    {emoji: "⛽"},
    {emoji: "🚧"},
    {emoji: "🚦"},
    {emoji: "🚥"},
    {emoji: "🚏"},
    {emoji: "🗿"},
    {emoji: "🗺️"},
    {emoji: "🗽"},
    {emoji: "🗼"},
    {emoji: "🏰"},
    {emoji: "🏯"},
    {emoji: "🏟️"},
    {emoji: "🎡"},
    {emoji: "🎢"},
    {emoji: "🎠"},
    {emoji: "⛲"},
    {emoji: "⛱️"},
    {emoji: "🏖️"},
    {emoji: "🏝️"},
    {emoji: "🏜️"},
    {emoji: "🌋"},
    {emoji: "⛰️"},
    {emoji: "🏔️"},
    {emoji: "🗻"},
    {emoji: "🏕️"},
    {emoji: "⛺"},
    {emoji: "🛖"},
    {emoji: "🏠"},
    {emoji: "🏡"},
    {emoji: "🏘️"},
    {emoji: "🏚️"},
    {emoji: "🏗️"},
    {emoji: "🏭"},
    {emoji: "🏢"},
    {emoji: "🏬"},
    {emoji: "🏣"},
    {emoji: "🏤"},
    {emoji: "🏥"},
    {emoji: "🏦"},
    {emoji: "🏨"},
    {emoji: "🏪"},
    {emoji: "🏫"},
    {emoji: "🏩"},
    {emoji: "💒"},
    {emoji: "🏛️"},
    {emoji: "⛪"},
    {emoji: "🕌"},
    {emoji: "🕍"},
    {emoji: "🛕"},
    {emoji: "🕋"},
    {emoji: "⛩️"},
    {emoji: "🛤️"},
    {emoji: "🛣️"},
    {emoji: "🗾"},
    {emoji: "🎑"},
    {emoji: "🏞️"},
    {emoji: "🌅"},
    {emoji: "🌄"},
    {emoji: "🌠"},
    {emoji: "🎇"},
    {emoji: "🎆"},
    {emoji: "🌇"},
    {emoji: "🌆"},
    {emoji: "🏙️"},
    {emoji: "🌃"},
    {emoji: "🌌"},
    {emoji: "🌉"},
    {emoji: "🌁"}
];

export const EmojisObjects = [
    {emoji: "⌚"},
    {emoji: "📱"},
    {emoji: "📲"},
    {emoji: "💻"},
    {emoji: "⌨️"},
    {emoji: "🖥️"},
    {emoji: "🖨️"},
    {emoji: "🖱️"},
    {emoji: "🖲️"},
    {emoji: "🕹️"},
    {emoji: "🗜️"},
    {emoji: "💽"},
    {emoji: "💾"},
    {emoji: "💿"},
    {emoji: "📀"},
    {emoji: "📷"},
    {emoji: "📼"},
    {emoji: "📸"},
    {emoji: "📹"},
    {emoji: "🎥"},
    {emoji: "📽️"},
    {emoji: "🎞️"},
    {emoji: "📞"},
    {emoji: "☎️"},
    {emoji: "📟"},
    {emoji: "📠"},
    {emoji: "📺"},
    {emoji: "📻"},
    {emoji: "🎙️"},
    {emoji: "🎚️"},
    {emoji: "🎛️"},
    {emoji: "🧭"},
    {emoji: "⏱️"},
    {emoji: "⏲️"},
    {emoji: "⏰"},
    {emoji: "🕰️"},
    {emoji: "⌛"},
    {emoji: "⏳"},
    {emoji: "📡"},
    {emoji: "🔋"},
    {emoji: "🪫"},
    {emoji: "🔌"},
    {emoji: "💡"},
    {emoji: "🔦"},
    {emoji: "🕯️"},
    {emoji: "🪔"},
    {emoji: "🧯"},
    {emoji: "🛢️"},
    {emoji: "💸"},
    {emoji: "💵"},
    {emoji: "💴"},
    {emoji: "💶"},
    {emoji: "💷"},
    {emoji: "🪙"},
    {emoji: "💰"},
    {emoji: "💳"},
    {emoji: "🪪"},
    {emoji: "💎"},
    {emoji: "⚖️"},
    {emoji: "🪜"},
    {emoji: "🧰"},
    {emoji: "🪛"},
    {emoji: "🔧"},
    {emoji: "🔨"},
    {emoji: "⚒️"},
    {emoji: "🛠️"},
    {emoji: "⛏️"},
    {emoji: "🪚"},
    {emoji: "🔩"},
    {emoji: "⚙️"},
    {emoji: "🪤"},
    {emoji: "🧱"},
    {emoji: "⛓️"},
    {emoji: "🧲"},
    {emoji: "🔫"},
    {emoji: "💣"},
    {emoji: "🧨"},
    {emoji: "🪓"},
    {emoji: "🔪"},
    {emoji: "🗡️"},
    {emoji: "⚔️"},
    {emoji: "🛡️"},
    {emoji: "🚬"},
    {emoji: "⚰️"},
    {emoji: "🪦"},
    {emoji: "⚱️"},
    {emoji: "🏺"},
    {emoji: "🔮"},
    {emoji: "📿"},
    {emoji: "🧿"},
    {emoji: "🪬"},
    {emoji: "💈"},
    {emoji: "⚗️"},
    {emoji: "🔭"},
    {emoji: "🔬"},
    {emoji: "🕳️"},
    {emoji: "🩻"},
    {emoji: "🩹"},
    {emoji: "🩺"},
    {emoji: "💊"},
    {emoji: "💉"},
    {emoji: "🩸"},
    {emoji: "🧬"},
    {emoji: "🦠"},
    {emoji: "🧪"},
    {emoji: "🧫"},
    {emoji: "🌡️"},
    {emoji: "🧹"},
    {emoji: "🪠"},
    {emoji: "🧺"},
    {emoji: "🧻"},
    {emoji: "🚽"},
    {emoji: "🚰"},
    {emoji: "🚿"},
    {emoji: "🛁"},
    {emoji: "🛀"},
    {emoji: "🧼"},
    {emoji: "🪥"},
    {emoji: "🪒"},
    {emoji: "🪮"},
    {emoji: "🧽"},
    {emoji: "🪣"},
    {emoji: "🧴"},
    {emoji: "🛎️"},
    {emoji: "🔑"},
    {emoji: "🗝️"},
    {emoji: "🚪"},
    {emoji: "🪑"},
    {emoji: "🛋️"},
    {emoji: "🛏️"},
    {emoji: "🛌"},
    {emoji: "🧸"},
    {emoji: "🪆"},
    {emoji: "🖼️"},
    {emoji: "🪞"},
    {emoji: "🪟"},
    {emoji: "🛍️"},
    {emoji: "🛒"},
    {emoji: "🎁"},
    {emoji: "🎈"},
    {emoji: "🎏"},
    {emoji: "🎀"},
    {emoji: "🪄"},
    {emoji: "🪅"},
    {emoji: "🎊"},
    {emoji: "🎉"},
    {emoji: "🎎"},
    {emoji: "🪭"},
    {emoji: "🏮"},
    {emoji: "🎐"},
    {emoji: "🪩"},
    {emoji: "🧧"},
    {emoji: "✉"},
    {emoji: "📩"},
    {emoji: "📨"},
    {emoji: "📧"},
    {emoji: "💌"},
    {emoji: "📥"},
    {emoji: "📤"},
    {emoji: "📦"},
    {emoji: "🏷️"},
    {emoji: "🪧"},
    {emoji: "📪"},
    {emoji: "📫"},
    {emoji: "📬"},
    {emoji: "📭"},
    {emoji: "📮"},
    {emoji: "📯"},
    {emoji: "📜"},
    {emoji: "📃"},
    {emoji: "📄"},
    {emoji: "📑"},
    {emoji: "🧾"},
    {emoji: "📊"},
    {emoji: "📈"},
    {emoji: "📉"},
    {emoji: "🗒️"},
    {emoji: "🗓️"},
    {emoji: "📆"},
    {emoji: "🗑️"},
    {emoji: "📇"},
    {emoji: "🗃️"},
    {emoji: "🗳️"},
    {emoji: "🗄️"},
    {emoji: "📋"},
    {emoji: "📁"},
    {emoji: "🗂️"},
    {emoji: "🗞️"},
    {emoji: "📰"},
    {emoji: "📓"},
    {emoji: "📔"},
    {emoji: "📕"},
    {emoji: "📗"},
    {emoji: "📘"},
    {emoji: "📙"},
    {emoji: "📚"},
    {emoji: "📖"},
    {emoji: "🔖"},
    {emoji: "🧷"},
    {emoji: "🔗"},
    {emoji: "📎"},
    {emoji: "🖇️"},
    {emoji: "📐"},
    {emoji: "📏"},
    {emoji: "🧮"},
    {emoji: "📌"},
    {emoji: "📍"},
    {emoji: "✂️"},
    {emoji: "🖊️"},
    {emoji: "🖋️"},
    {emoji: "✒️"},
    {emoji: "🖌️"},
    {emoji: "🖍️"},
    {emoji: "📝"},
    {emoji: "✏️"},
    {emoji: "🔍"},
    {emoji: "🔎"},
    {emoji: "🔏"},
    {emoji: "🔐"},
    {emoji: "🔒"},
    {emoji: "🔓"}
];

export const EmojisCountryFlags = [
    {emoji: "🇦🇫"},
    {emoji: "🇦🇱"},
    {emoji: "🇩🇿"},
    {emoji: "🇦🇸"},
    {emoji: "🇦🇩"},
    {emoji: "🇦🇴"},
    {emoji: "🇦🇮"},
    {emoji: "🇦🇶"},
    {emoji: "🇦🇬"},
    {emoji: "🇦🇷"},
    {emoji: "🇦🇲"},
    {emoji: "🇦🇼"},
    {emoji: "🇦🇺"},
    {emoji: "🇦🇹"},
    {emoji: "🇦🇿"},
    {emoji: "🇧🇸"},
    {emoji: "🇧🇭"},
    {emoji: "🇧🇩"},
    {emoji: "🇧🇧"},
    {emoji: "🇧🇾"},
    {emoji: "🇧🇪"},
    {emoji: "🇧🇿"},
    {emoji: "🇧🇯"},
    {emoji: "🇧🇲"},
    {emoji: "🇧🇹"},
    {emoji: "🇧🇴"},
    {emoji: "🇧🇦"},
    {emoji: "🇧🇼"},
    {emoji: "🇧🇷"},
    {emoji: "🇧🇳"},
    {emoji: "🇧🇬"},
    {emoji: "🇧🇫"},
    {emoji: "🇧🇮"},
    {emoji: "🇨🇻"},
    {emoji: "🇰🇭"},
    {emoji: "🇨🇲"},
    {emoji: "🇨🇦"},
    {emoji: "🇨🇫"},
    {emoji: "🇹🇩"},
    {emoji: "🇨🇱"},
    {emoji: "🇨🇳"},
    {emoji: "🇨🇴"},
    {emoji: "🇰🇲"},
    {emoji: "🇨🇬"},
    {emoji: "🇨🇩"},
    {emoji: "🇨🇷"},
    {emoji: "🇭🇷"},
    {emoji: "🇨🇺"},
    {emoji: "🇨🇾"},
    {emoji: "🇨🇿"},
    {emoji: "🇩🇰"},
    {emoji: "🇩🇯"},
    {emoji: "🇩🇲"},
    {emoji: "🇩🇴"},
    {emoji: "🇪🇨"},
    {emoji: "🇪🇬"},
    {emoji: "🇸🇻"},
    {emoji: "🇬🇶"},
    {emoji: "🇪🇷"},
    {emoji: "🇪🇪"},
    {emoji: "🇸🇿"},
    {emoji: "🇪🇹"},
    {emoji: "🇫🇯"},
    {emoji: "🇫🇮"},
    {emoji: "🇫🇷"},
    {emoji: "🇬🇦"},
    {emoji: "🇬🇲"},
    {emoji: "🇬🇪"},
    {emoji: "🇩🇪"},
    {emoji: "🇬🇭"},
    {emoji: "🇬🇷"},
    {emoji: "🇬🇩"},
    {emoji: "🇬🇹"},
    {emoji: "🇬🇳"},
    {emoji: "🇬🇼"},
    {emoji: "🇬🇾"},
    {emoji: "🇭🇹"},
    {emoji: "🇭🇳"},
    {emoji: "🇭🇺"},
    {emoji: "🇮🇸"},
    {emoji: "🇮🇳"},
    {emoji: "🇮🇩"},
    {emoji: "🇮🇷"},
    {emoji: "🇮🇶"},
    {emoji: "🇮🇪"},
    {emoji: "🇮🇱"},
    {emoji: "🇮🇹"},
    {emoji: "🇯🇲"},
    {emoji: "🇯🇵"},
    {emoji: "🇯🇴"},
    {emoji: "🇰🇿"},
    {emoji: "🇰🇪"},
    {emoji: "🇰🇮"},
    {emoji: "🇰🇼"},
    {emoji: "🇰🇬"},
    {emoji: "🇱🇦"},
    {emoji: "🇱🇻"},
    {emoji: "🇱🇧"},
    {emoji: "🇱🇸"},
    {emoji: "🇱🇷"},
    {emoji: "🇱🇾"},
    {emoji: "🇱🇮"},
    {emoji: "🇱🇹"},
    {emoji: "🇱🇺"},
    {emoji: "🇲🇬"},
    {emoji: "🇲🇼"},
    {emoji: "🇲🇾"},
    {emoji: "🇲🇻"},
    {emoji: "🇲🇱"},
    {emoji: "🇲🇹"},
    {emoji: "🇲🇭"},
    {emoji: "🇲🇷"},
    {emoji: "🇲🇺"},
    {emoji: "🇲🇽"},
    {emoji: "🇫🇲"},
    {emoji: "🇲🇩"},
    {emoji: "🇲🇨"},
    {emoji: "🇲🇳"},
    {emoji: "🇲🇪"},
    {emoji: "🇲🇦"},
    {emoji: "🇲🇿"},
    {emoji: "🇲🇲"},
    {emoji: "🇳🇦"},
    {emoji: "🇳🇷"},
    {emoji: "🇳🇵"},
    {emoji: "🇳🇱"},
    {emoji: "🇳🇿"},
    {emoji: "🇳🇮"},
    {emoji: "🇳🇪"},
    {emoji: "🇳🇬"},
    {emoji: "🇰🇵"},
    {emoji: "🇲🇰"},
    {emoji: "🇳🇴"},
    {emoji: "🇴🇲"},
    {emoji: "🇵🇰"},
    {emoji: "🇵🇼"},
    {emoji: "🇵🇦"},
    {emoji: "🇵🇬"},
    {emoji: "🇵🇾"},
    {emoji: "🇵🇪"},
    {emoji: "🇵🇭"},
    {emoji: "🇵🇱"},
    {emoji: "🇵🇹"},
    {emoji: "🇶🇦"},
    {emoji: "🇷🇴"},
    {emoji: "🇷🇺"},
    {emoji: "🇷🇼"},
    {emoji: "🇰🇳"},
    {emoji: "🇱🇨"},
    {emoji: "🇻🇨"},
    {emoji: "🇼🇸"},
    {emoji: "🇸🇲"},
    {emoji: "🇸🇹"},
    {emoji: "🇸🇦"},
    {emoji: "🇸🇳"},
    {emoji: "🇷🇸"},
    {emoji: "🇸🇨"},
    {emoji: "🇸🇱"},
    {emoji: "🇸🇬"},
    {emoji: "🇸🇰"},
    {emoji: "🇸🇮"},
    {emoji: "🇸🇧"},
    {emoji: "🇸🇴"},
    {emoji: "🇿🇦"},
    {emoji: "🇰🇷"},
    {emoji: "🇸🇸"},
    {emoji: "🇪🇸"},
    {emoji: "🇱🇰"},
    {emoji: "🇸🇩"},
    {emoji: "🇸🇷"},
    {emoji: "🇸🇪"},
    {emoji: "🇨🇭"},
    {emoji: "🇸🇾"},
    {emoji: "🇹🇼"},
    {emoji: "🇹🇯"},
    {emoji: "🇹🇿"},
    {emoji: "🇹🇭"},
    {emoji: "🇹🇱"},
    {emoji: "🇹🇬"},
    {emoji: "🇹🇴"},
    {emoji: "🇹🇹"},
    {emoji: "🇹🇳"},
    {emoji: "🇹🇷"},
    {emoji: "🇹🇲"},
    {emoji: "🇹🇻"},
    {emoji: "🇺🇬"},
    {emoji: "🇺🇦"},
    {emoji: "🇦🇪"},
    {emoji: "🇬🇧"},
    {emoji: "🇺🇸"},
    {emoji: "🇺🇾"},
    {emoji: "🇺🇿"},
    {emoji: "🇻🇺"},
    {emoji: "🇻🇦"},
    {emoji: "🇻🇪"},
    {emoji: "🇻🇳"},
    {emoji: "🇾🇪"},
    {emoji: "🇿🇲"},
    {emoji: "🇿🇼"}
];

export const CountryWithFlags = [
    { emoji: "🇦🇫", name: "Afghanistan" },
    { emoji: "🇦🇱", name: "Albania" },
    { emoji: "🇩🇿", name: "Algeria" },
    { emoji: "🇦🇸", name: "American Samoa"},
    { emoji: "🇦🇩", name: "Andorra" },
    { emoji: "🇦🇴", name: "Angola" },
    { emoji: "🇦🇮", name: "Anguilla" },
    { emoji: "🇦🇶", name: "Antarctica" },
    { emoji: "🇦🇬", name: "Antigua and Barbuda" },
    { emoji: "🇦🇷", name: "Argentina" },
    { emoji: "🇦🇲", name: "Armenia" },
    { emoji: "🇦🇼", name: "Aruba" },
    { emoji: "🇦🇺", name: "Australia" },
    { emoji: "🇦🇹", name: "Austria" },
    { emoji: "🇦🇿", name: "Azerbaijan" },
    { emoji: "🇧🇸", name: "Bahamas" },
    { emoji: "🇧🇭", name: "Bahrain" },
    { emoji: "🇧🇩", name: "Bangladesh" },
    { emoji: "🇧🇧", name: "Barbados" },
    { emoji: "🇧🇾", name: "Belarus" },
    { emoji: "🇧🇪", name: "Belgium" },
    { emoji: "🇧🇿", name: "Belize" },
    { emoji: "🇧🇯", name: "Benin" },
    { emoji: "🇧🇲", name: "Bermuda" },
    { emoji: "🇧🇹", name: "Bhutan" },
    { emoji: "🇧🇴", name: "Bolivia" },
    { emoji: "🇧🇦", name: "Bosnia and Herzegovina" },
    { emoji: "🇧🇼", name: "Botswana" },
    { emoji: "🇧🇷", name: "Brazil" },
    { emoji: "🇮🇴", name: "British Indian Ocean Territory" },
    { emoji: "🇻🇬", name: "British Virgin Islands" },
    { emoji: "🇧🇳", name: "Brunei" },
    { emoji: "🇧🇬", name: "Bulgaria" },
    { emoji: "🇧🇫", name: "Burkina Faso" },
    { emoji: "🇧🇮", name: "Burundi" },
    { emoji: "🇰🇭", name: "Cambodia" },
    { emoji: "🇨🇲", name: "Cameroon" },
    { emoji: "🇨🇦", name: "Canada" },
    { emoji: "🇮🇨", name: "Canary Islands" },
    { emoji: "🇨🇻", name: "Cape Verde" },
    { emoji: "🇧🇶", name: "Caribbean Netherlands" },
    { emoji: "🇰🇾", name: "Cayman Islands" },
    { emoji: "🇨🇫", name: "Central African Republic" },
    { emoji: "🇹🇩", name: "Chad" },
    { emoji: "🇨🇱", name: "Chile" },
    { emoji: "🇨🇳", name: "China" },
    { emoji: "🇨🇽", name: "Christmas Island" },
    { emoji: "🇨🇨", name: "Cocos (Keeling) Islands" },
    { emoji: "🇨🇴", name: "Colombia" },
    { emoji: "🇰🇲", name: "Comoros" },
    { emoji: "🇨🇬", name: "Congo - Brazzaville" },
    { emoji: "🇨🇩", name: "Congo - Kinshasa" },
    { emoji: "🇨🇰", name: "Cook Islands" },
    { emoji: "🇨🇷", name: "Costa Rica" },
    { emoji: "🇨🇮", name: "Côte d'Ivoire" },
    { emoji: "🇭🇷", name: "Croatia" },
    { emoji: "🇨🇺", name: "Cuba" },
    { emoji: "🇨🇼", name: "Curaçao" },
    { emoji: "🇨🇾", name: "Cyprus" },
    { emoji: "🇨🇿", name: "Czechia" },
    { emoji: "🇩🇰", name: "Denmark" },
    { emoji: "🇩🇯", name: "Djibouti" },
    { emoji: "🇩🇲", name: "Dominica" },
    { emoji: "🇩🇴", name: "Dominican Republic" },
    { emoji: "🇪🇨", name: "Ecuador" },
    { emoji: "🇪🇬", name: "Egypt" },
    { emoji: "🇸🇻", name: "El Salvador" },
    { emoji: "🇬🇶", name: "Equatorial Guinea" },
    { emoji: "🇪🇷", name: "Eritrea" },
    { emoji: "🇪🇪", name: "Estonia" },
    { emoji: "🇸🇿", name: "Eswatini" },
    { emoji: "🇪🇹", name: "Ethiopia" },
    { emoji: "🇪🇺", name: "European Union" },
    { emoji: "🇫🇰", name: "Falkland Islands" },
    { emoji: "🇫🇴", name: "Faroe Islands" },
    { emoji: "🇫🇯", name: "Fiji" },
    { emoji: "🇫🇮", name: "Finland" },
    { emoji: "🇫🇷", name: "France" },
    { emoji: "🇬🇫", name: "French Guiana" },
    { emoji: "🇵🇫", name: "French Polynesia" },
    { emoji: "🇹🇫", name: "French Southern Territories" },
    { emoji: "🇬🇦", name: "Gabon" },
    { emoji: "🇬🇲", name: "Gambia" },
    { emoji: "🇬🇪", name: "Georgia" },
    { emoji: "🇩🇪", name: "Germany" },
    { emoji: "🇬🇭", name: "Ghana" },
    { emoji: "🇬🇮", name: "Gibraltar" },
    { emoji: "🇬🇷", name: "Greece" },
    { emoji: "🇬🇱", name: "Greenland" },
    { emoji: "🇬🇩", name: "Grenada" },
    { emoji: "🇬🇵", name: "Guadeloupe" },
    { emoji: "🇬🇺", name: "Guam" },
    { emoji: "🇬🇹", name: "Guatemala" },
    { emoji: "🇬🇬", name: "Guernsey" },
    { emoji: "🇬🇳", name: "Guinea" },
    { emoji: "🇬🇼", name: "Guinea-Bissau" },
    { emoji: "🇬🇾", name: "Guyana" },
    { emoji: "🇭🇹", name: "Haiti" },
    { emoji: "🇭🇲", name: "Heard & McDonald Islands" },
    { emoji: "🇻🇦", name: "Vatican City" },
    { emoji: "🇭🇳", name: "Honduras" },
    { emoji: "🇭🇰", name: "Hong Kong SAR China" },
    { emoji: "🇭🇺", name: "Hungary" },
    { emoji: "🇮🇸", name: "Iceland" },
    { emoji: "🇮🇳", name: "India" },
    { emoji: "🇮🇩", name: "Indonesia" },
    { emoji: "🇮🇷", name: "Iran" },
    { emoji: "🇮🇶", name: "Iraq" },
    { emoji: "🇮🇪", name: "Ireland" },
    { emoji: "🇮🇲", name: "Isle of Man" },
    { emoji: "🇮🇱", name: "Israel" },
    { emoji: "🇮🇹", name: "Italy" },
    { emoji: "🇨🇮", name: "Ivory Coast" },
    { emoji: "🇯🇲", name: "Jamaica" },
    { emoji: "🇯🇵", name: "Japan" },
    { emoji: "🇯🇪", name: "Jersey" },
    { emoji: "🇯🇴", name: "Jordan" },
    { emoji: "🇰🇿", name: "Kazakhstan" },
    { emoji: "🇰🇪", name: "Kenya" },
    { emoji: "🇰🇮", name: "Kiribati" },
    { emoji: "🇽🇰", name: "Kosovo" },
    { emoji: "🇰🇼", name: "Kuwait" },
    { emoji: "🇰🇬", name: "Kyrgyzstan" },
    { emoji: "🇱🇦", name: "Laos" },
    { emoji: "🇱🇻", name: "Latvia" },
    { emoji: "🇱🇧", name: "Lebanon" },
    { emoji: "🇱🇸", name: "Lesotho" },
    { emoji: "🇱🇷", name: "Liberia" },
    { emoji: "🇱🇾", name: "Libya" },
    { emoji: "🇱🇮", name: "Liechtenstein" },
    { emoji: "🇱🇹", name: "Lithuania" },
    { emoji: "🇱🇺", name: "Luxembourg" },
    { emoji: "🇲🇬", name: "Madagascar" },
    { emoji: "🇲🇼", name: "Malawi" },
    { emoji: "🇲🇾", name: "Malaysia" },
    { emoji: "🇲🇻", name: "Maldives" },
    { emoji: "🇲🇱", name: "Mali" },
    { emoji: "🇲🇹", name: "Malta" },
    { emoji: "🇲🇭", name: "Marshall Islands" },
    { emoji: "🇲🇷", name: "Mauritania" },
    { emoji: "🇲🇺", name: "Mauritius" },
    { emoji: "🇲🇽", name: "Mexico" },
    { emoji: "🇫🇲", name: "Micronesia" },
    { emoji: "🇲🇩", name: "Moldova" },
    { emoji: "🇲🇨", name: "Monaco" },
    { emoji: "🇲🇳", name: "Mongolia" },
    { emoji: "🇲🇪", name: "Montenegro" },
    { emoji: "🇲🇦", name: "Morocco" },
    { emoji: "🇲🇿", name: "Mozambique" },
    { emoji: "🇲🇲", name: "Myanmar" },
    { emoji: "🇳🇦", name: "Namibia" },
    { emoji: "🇳🇷", name: "Nauru" },
    { emoji: "🇳🇵", name: "Nepal" },
    { emoji: "🇳🇱", name: "Netherlands" },
    { emoji: "🇳🇿", name: "New Zealand" },
    { emoji: "🇳🇮", name: "Nicaragua" },
    { emoji: "🇳🇪", name: "Niger" },
    { emoji: "🇳🇬", name: "Nigeria" },
    { emoji: "🇰🇵", name: "North Korea" },
    { emoji: "🇲🇰", name: "North Macedonia" },
    { emoji: "🇳🇴", name: "Norway" },
    { emoji: "🇴🇲", name: "Oman" },
    { emoji: "🇵🇰", name: "Pakistan" },
    { emoji: "🇵🇼", name: "Palau" },
    { emoji: "🇵🇦", name: "Panama" },
    { emoji: "🇵🇬", name: "Papua New Guinea" },
    { emoji: "🇵🇾", name: "Paraguay" },
    { emoji: "🇵🇪", name: "Peru" },
    { emoji: "🇵🇭", name: "Philippines" },
    { emoji: "🇵🇱", name: "Poland" },
    { emoji: "🇵🇹", name: "Portugal" },
    { emoji: "🇶🇦", name: "Qatar" },
    { emoji: "🇷🇴", name: "Romania" },
    { emoji: "🇷🇺", name: "Russia" },
    { emoji: "🇷🇼", name: "Rwanda" },
    { emoji: "🇰🇳", name: "Saint Kitts and Nevis" },
    { emoji: "🇱🇨", name: "Saint Lucia" },
    { emoji: "🇻🇨", name: "Saint Vincent and the Grenadines" },
    { emoji: "🇼🇸", name: "Samoa" },
    { emoji: "🇸🇲", name: "San Marino" },
    { emoji: "🇸🇹", name: "Sao Tome and Principe" },
    { emoji: "🇸🇦", name: "Saudi Arabia" },
    { emoji: "🇸🇳", name: "Senegal" },
    { emoji: "🇷🇸", name: "Serbia" },
    { emoji: "🇸🇨", name: "Seychelles" },
    { emoji: "🇸🇱", name: "Sierra Leone" },
    { emoji: "🇸🇬", name: "Singapore" },
    { emoji: "🇸🇰", name: "Slovakia" },
    { emoji: "🇸🇮", name: "Slovenia" },
    { emoji: "🇸🇧", name: "Solomon Islands" },
    { emoji: "🇸🇴", name: "Somalia" },
    { emoji: "🇿🇦", name: "South Africa" },
    { emoji: "🇰🇷", name: "South Korea" },
    { emoji: "🇸🇸", name: "South Sudan" },
    { emoji: "🇪🇸", name: "Spain" },
    { emoji: "🇱🇰", name: "Sri Lanka" },
    { emoji: "🇸🇩", name: "Sudan" },
    { emoji: "🇸🇷", name: "Suriname" },
    { emoji: "🇸🇪", name: "Sweden" },
    { emoji: "🇨🇭", name: "Switzerland" },
    { emoji: "🇸🇾", name: "Syria" },
    { emoji: "🇹🇼", name: "Taiwan" },
    { emoji: "🇹🇯", name: "Tajikistan" },
    { emoji: "🇹🇿", name: "Tanzania" },
    { emoji: "🇹🇭", name: "Thailand" },
    { emoji: "🇹🇱", name: "Timor-Leste" },
    { emoji: "🇹🇬", name: "Togo"},
    { emoji: "🇹🇴", name: "Tonga" },
    { emoji: "🇹🇹", name: "Trinidad and Tobago" },
    { emoji: "🇹🇳", name: "Tunisia" },
    { emoji: "🇹🇷", name: "Turkey" },
    { emoji: "🇹🇲", name: "Turkmenistan" },
    { emoji: "🇹🇻", name: "Tuvalu" },
    { emoji: "🇺🇬", name: "Uganda" },
    { emoji: "🇺🇦", name: "Ukraine" },
    { emoji: "🇦🇪", name: "United Arab Emirates" },
    { emoji: "🇬🇧", name: "United Kingdom" },
    { emoji: "🇺🇸", name: "United States" },
    { emoji: "🇺🇾", name: "Uruguay" },
    { emoji: "🇺🇿", name: "Uzbekistan" },
    { emoji: "🇻🇺", name: "Vanuatu" },
    { emoji: "🇻🇦", name: "Vatican City" },
    { emoji: "🇻🇪", name: "Venezuela" },
    { emoji: "🇻🇳", name: "Vietnam"},
    { emoji: "🇾🇪", name: "Yemen" },
    { emoji: "🇿🇲", name: "Zambia" },
    { emoji: "🇿🇼", name: "Zimbabwe" }
]